import Image from "next/legacy/image";
import Link from "next/link";
import { startCase } from "lodash";
import moment from "moment";
import { Hit } from "react-instantsearch-core";
import "moment/locale/es-mx";

import RightArrowIcon from "../../../public/img/arrow-right-for-next-button.svg";
import { urlFor } from "../../../src/cms-blog-api/sanity";
import { IndexedPost } from "../../../src/types/blog";

type SearchPostItemProps = {
  indexedPost: unknown;
  closeSearch: Function;
};

export default function SearchPostItem({
  indexedPost,
  closeSearch,
}: SearchPostItemProps) {
  const { title, category, summary, image, slug, objectID, createdAt, author } =
    indexedPost as IndexedPost & Hit<IndexedPost>;

  return (
    <div
      key={objectID}
      className="grid grid-cols-12 gap-x-2 sm:gap-x-3 md:gap-x-4 lg:gap-x-5 px-2 py-3"
    >
      <div className="col-span-12 sm:col-span-5 lg:col-span-4 flex flex-col justify-center">
        <Link href={`/blog/${slug}`}>
          <button
            onClick={() => closeSearch()}
            className="relative rounded-lg shadow-post-image cursor-pointer aspect-w-16 aspect-h-8"
          >
            <Image
              className="rounded-lg"
              src={urlFor(image).url()}
              layout="fill"
              objectFit="cover"
              alt={image.altText}
              placeholder="blur"
              blurDataURL={image.asset.metadata.lqip}
              sizes="15vw"
            />
          </button>
        </Link>
      </div>

      <div className="col-span-12 sm:col-span-7 lg:col-span-8 space-y-2 py-2 lg:py-0">
        <Link href={`/blog/${slug}`}>
          <button
            onClick={() => closeSearch()}
            className="text-lg text-white font-semibold cursor-pointer text-left"
          >
            {title}
          </button>
        </Link>
        <p className="text-xs text-gray-500">
          <span>{startCase(moment(createdAt).format("D MMMM YYYY"))}</span>
          <span className="font-bold">{` | `}</span>
          <span>{category}</span>
          <span className="font-bold">{` | `}</span>
          <span>{author}</span>
        </p>
        <p className="text-sm line-clamp-2 text-gray-300">{summary}</p>
        <Link href={`/blog/${slug}`}>
          <button
            onClick={() => closeSearch()}
            className="text-sm flex flex-row items-center gap-x-1 text-bi-green-malachite-600 hover:underline w-max"
          >
            <span>Leer nota completa</span>
            <span>
              <RightArrowIcon className="w-4 h-4" />
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
}
